export const UPDATE_CUSTOMER = "UPDATE_CUSTOMER";
export const CUSTOMER_LOGIN_SUCCESS = "CUSTOMER_LOGIN_SUCCESS";
export const CUSTOMER_LOGOUT = "CUSTOMER_LOGOUT";
export const TRIGGER_LOGIN = "TRIGGER_LOGIN";
export const CLEAR_TRIGGER_LOGIN = "CLEAR_TRIGGER_LOGIN";
